import apiService, { BaseURL } from "../../../../service/Api";
import type { IdentityVerification } from "./types";

const PATH = "/api/chema/identity-verifications/";

export async function listIdentityVerifications(
  status?: string,
): Promise<IdentityVerification[]> {
  const params = status && status !== "all" ? { status } : undefined;
  const res = await apiService.get<
    IdentityVerification[] | { results: IdentityVerification[] }
  >(PATH, params);
  const data = res.data;
  if (Array.isArray(data)) return data;
  if (data?.results) return data.results;
  return [];
}

export async function reviewIdentityVerification(
  id: number,
  action: "approve" | "reject",
  rejectionReason?: string,
): Promise<IdentityVerification> {
  const payload: Record<string, string> = {
    status: action === "approve" ? "approved" : "rejected",
  };
  if (rejectionReason) payload.rejection_reason = rejectionReason;
  const res = await apiService.patch<IdentityVerification>(
    `${PATH}${id}/`,
    payload,
  );
  return res.data;
}

export function buildDocUrl(path: string | null): string | null {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  const base = BaseURL.endsWith("/") ? BaseURL.slice(0, -1) : BaseURL;
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

export const DOC_TYPE_LABELS: Record<string, string> = {
  national_id: "National ID",
  passport: "Passport",
  drivers_license: "Driver's Licence",
};
